var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#479FFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5238 21.6667L24.7619 26.6667L20 21.6667L15.2381 26.6667L10.4762 21.6667",
    stroke: "black",
    strokeWidth: 1.7525
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2619 16.2583C14.1467 15.3261 15.1981 14.5864 16.3557 14.0816C17.5133 13.5769 18.7545 13.3171 20.0079 13.3171C21.2614 13.3171 22.5025 13.5769 23.6602 14.0816C24.8178 14.5864 25.8692 15.3261 26.754 16.2583",
    stroke: "black",
    strokeWidth: 1.7525
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo5);
export default __webpack_public_path__ + "static/media/logo5.442957a376c2bfd0531c5ca06e983593.svg";
export { ForwardRef as ReactComponent };